import { render, staticRenderFns } from "./exam-link.vue?vue&type=template&id=fb9bdcdc&scoped=true"
import script from "./exam-link.vue?vue&type=script&lang=ts"
export * from "./exam-link.vue?vue&type=script&lang=ts"
import style0 from "./exam-link.vue?vue&type=style&index=0&id=fb9bdcdc&prod&lang=scss"
import style1 from "./exam-link.vue?vue&type=style&index=1&id=fb9bdcdc&prod&lang=scss"
import style2 from "./exam-link.vue?vue&type=style&index=2&id=fb9bdcdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9bdcdc",
  null
  
)

export default component.exports